import { FC, ReactNode, useCallback } from "react"
import { IconButton, IconButtonProps } from "@mui/material"
import { isFunction } from "lodash"

import { ShareIcon } from "components/icons"

interface IShareIconButton extends IconButtonProps {
  title?: string
  text?: string
  url?: string
  shareIcon?: ReactNode
}

export const ShareIconButton: FC<IShareIconButton> = ({
  title,
  text,
  url,
  onClick,
  shareIcon = <ShareIcon />,
  ...props
}) => {
  const isSharebale = !!navigator.share
  const handleClick = useCallback(
    async (event) => {
      if (isFunction(onClick)) onClick(event)

      if (navigator.share) {
        try {
          await navigator.share({ title, text, url })
          alert("Share successfull")
        } catch (err) {
          console.log("Error: ", err)
        }
      } else {
        console.log("Native Web Sharing not supported")
      }
    },
    [onClick, text, title, url]
  )
  return (
    isSharebale && (
      <IconButton color="primary" onClick={handleClick} {...props}>
        {shareIcon}
      </IconButton>
    )
  )
}
